import type { NextPage } from 'next'
import Head from 'next/head'

import { Project } from '../../types/project'

// 1. DADOS DO PROJETO
const projects: Project[] = [
    {
        slug: 'quimlab',
        title: 'QuimLab',
        description:
            'Aplicação web e mobile que usa visão computacional para resolver problemas químicos',
        category: 'Visão computacional e IA',
        tags: ['HTML, XML e CSS', 'kotlin', 'JavaScript', 'OpenCV', 'Gimini'],
        isExternalUrl: true,
        url: 'https://quimlab.netlify.app/',
        logo: '/images/projects/quimlab.png',
    },
    {
        slug: 'mobus',
        title: 'Mobus',
        description:
            'Plataforma de mobilidade urbana que conecta motoristas e passageiros através do rastreamento de ônibus em tempo real via geolocalização',
        category: 'Mobilidade Urbana',
        tags: ['Flutter', 'Dart', 'Firebase', 'OpenStreetMap'],
        isExternalUrl: true,
        url: 'https://mobusproject.netlify.app/',
        logo: '/images/projects/mobus.png',
    },
    // Se quiser adicionar mais projetos, basta duplicar o objeto acima
]

// 2. O COMPONENTE VISUAL (Adaptado para Lig0t/Dark Mode)
const MiniDegensPage: NextPage = () => {
    return (
        // AJUSTE FEITO AQUI: mudei de 'pt-10' para 'pt-4' para subir o conteúdo
        <div className="px0 pt0 container mx-auto max-w-3xl pb-20">
            <Head>
                <title>Projetos da Faculdade</title>
            </Head>

            <header className="mb-10">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                    Projetos da Faculdade
                </h1>
                <p className="mt-2 text-gray-600 dark:text-gray-400">
                    Trabalhos acadêmicos, pesquisas e experimentos desenvolvidos durante o
                    curso.
                </p>
            </header>

            <div className="grid gap-6">
                {projects.map((project) => (
                    <div
                        key={project.slug}
                        className="group relative flex flex-col gap-6 rounded-xl border border-gray-200 bg-white p-6
              shadow-sm transition-all hover:border-gray-300 hover:shadow-md md:flex-row
              dark:border-slate-700/50 dark:bg-[#1e293b]/50 dark:shadow-none dark:hover:border-slate-600 dark:hover:bg-[#1e293b]"
                    >
                        {/* Ícone/Logo Esquerda */}
                        <div className="shrink-0">
                            <div
                                className="flex size-16 items-center justify-center overflow-hidden rounded-lg 
                bg-gray-100 dark:bg-slate-800"
                            >
                                {project.logo ? (
                                    <img
                                        src={project.logo}
                                        alt={project.title}
                                        className="size-full object-cover"
                                    />
                                ) : (
                                    <span className="text-2xl">💻</span>
                                )}
                            </div>
                        </div>

                        {/* Conteúdo Direita */}
                        <div className="min-w-0 flex-1">
                            <div className="flex items-start justify-between">
                                <h3 className="truncate pr-4 text-xl font-bold text-gray-900 dark:text-white">
                                    {project.title}
                                </h3>

                                {/* Ícones Topo Direita (Pin e Link Externo) */}
                                <div className="flex items-center gap-3 text-gray-400 dark:text-gray-500">
                                    {project.pin && (
                                        <svg
                                            className="size-5 text-gray-500 dark:text-white"
                                            fill="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M16 12V4H17V2H7V4H8V12L6 14V16H11V22H13V16H18V14L16 12Z" />
                                        </svg>
                                    )}
                                    {project.isExternalUrl && (
                                        <a
                                            href={project.url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="transition-colors hover:text-gray-700 dark:hover:text-white"
                                        >
                                            <svg
                                                className="size-5"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                                />
                                            </svg>
                                        </a>
                                    )}
                                </div>
                            </div>

                            <p className="mt-1 line-clamp-2 text-gray-600 dark:text-gray-400">
                                {project.description}
                            </p>

                            {/* Tags */}
                            <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-xs font-medium text-gray-500 dark:text-gray-500">
                                {project.tags?.map((tag) => (
                                    <span
                                        key={tag}
                                        className="cursor-default rounded bg-gray-100 px-2 py-1 text-gray-600 transition-colors hover:text-gray-900 
                    dark:bg-slate-800 dark:text-gray-400 dark:hover:text-gray-300"
                                    >
                                        {tag}
                                    </span>
                                ))}
                            </div>

                            {/* Link e Categoria Rodapé */}
                            <div className="mt-3 flex items-center gap-2 text-xs">
                                {project.url && (
                                    <a
                                        href={project.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-gray-600 transition-colors hover:text-gray-900 hover:underline dark:text-gray-400 dark:hover:text-white"
                                    >
                                        {project.url.replace(/^https?:\/\//, '')}
                                    </a>
                                )}
                                <span className="text-gray-400 dark:text-gray-600">•</span>
                                <span className="text-gray-500 dark:text-gray-500">
                                    {project.category}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default MiniDegensPage
